import '../styles/global.css';

const LoginLayout = ({ children }) => {
    return (
        <div>
            {children}
        </div>
    );
};

export default LoginLayout;
